import React from "react";
import { useParams } from "react-router-dom";
import "./RewardSecThree.css";

function RewardSecThree(props) {

  const { uniqueID } = useParams();
  console.log("uniqueID banner", uniqueID)
  return (
    <>
      {/* <div>RewardSecOne</div> */}
      {/* <img src="https://all-frontend-assets.s3.amazonaws.com/share4rewards/demoimage4.jpg" /> */}

      <div className="sb_block3_mainwrap">
        <div className="share4rewards-container">
          <div className="share4rewards_content_wrapper">
            <h1>Example of our shared media</h1>
            {props.mediaBanner ?
              <div className="sbcard_content_wrap" dangerouslySetInnerHTML={{ __html: props.mediaBanner }}></div>
              :
              <div className="sbcard_content_wrap">
                <div className="sbcard_content">
                  {uniqueID && uniqueID === "inland" ?
                    <img src="https://all-frontend-assets.s3.amazonaws.com/share4rewards/ieim_Example_of_our_shared_media_image1.jpg" /> :
                    <img src="https://all-frontend-assets.s3.amazonaws.com/share4rewards/block3_leftimg.webp" alt="" />
                  }
                </div>
                <div className="sbcard_content">
                  {uniqueID && uniqueID === "inland" ?
                    <img src="https://all-frontend-assets.s3.amazonaws.com/share4rewards/ieim_Example_of_our_shared_media_image2.jpg" /> :
                    <img src="https://all-frontend-assets.s3.amazonaws.com/share4rewards/block3_rightimg.webp" alt="" />
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </>
  );
}


export default RewardSecThree;
